var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C1C5D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9144 15.0257L19.9196 11.0205C20.2125 10.7276 20.6874 10.7276 20.9803 11.0205C21.2732 11.3133 21.2732 11.7882 20.9803 12.0811L16.9751 16.0863L20.9803 20.0915C21.2732 20.3844 21.2732 20.8593 20.9803 21.1522C20.6874 21.4451 20.2125 21.4451 19.9196 21.1522L15.9144 17.147L11.9092 21.1522C11.6163 21.4451 11.1415 21.4451 10.8486 21.1522C10.5557 20.8593 10.5557 20.3844 10.8486 20.0915L14.8538 16.0863L10.8486 12.0811C10.5557 11.7882 10.5557 11.3133 10.8486 11.0205C11.1415 10.7276 11.6163 10.7276 11.9092 11.0205L15.9144 15.0257Z",
    fill: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e17f681d782e1df92e331728864e71a4.svg";
export { ForwardRef as ReactComponent };